import { type DietaryRestrictionsText } from '@hungryroot/dietary-restrictions';

export function getWarningTextForModal(
  dietaryIngredients: DietaryRestrictionsText[]
) {
  if (dietaryIngredients.length === 1) {
    return dietaryIngredients[0];
  } else if (dietaryIngredients.length === 2) {
    return dietaryIngredients?.join(' + ');
  } else {
    return (
      dietaryIngredients?.slice(0, -1).join(', ') +
      ' + ' +
      dietaryIngredients?.slice(-1)
    );
  }
}
